/*  ──────────────────────────────────────────────────────────────────────
    src/components/auth/firestore/getUserDetails.ts
    One-shot hook/helper – always hits callable, never reads Firestore.
    ------------------------------------------------------------------ */
import { getFunctions, httpsCallable } from "firebase/functions";

export interface UserDoc {
  email: string | null;
  qrID: string;
  referralCode: string;
  createdOn: any;
  roles: string[];
  birthday: string | null;
}

const getUserData = async (): Promise<UserDoc | null> => {
  try {
    const functions = getFunctions();
    const createOrFetchUser = httpsCallable<void, { user: UserDoc }>(
      functions,
      "createOrFetchUser"
    );

    const { data } = await createOrFetchUser();
    return data.user;
  } catch (err) {
    console.error("getUserData failed", err);
    return null;
  }
};

export default getUserData;

export interface UserProfile {
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  birthday?: string;
  referralCode?: string;
}
